import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import * as brandActions from "src/redux/actions/brand.action";
import * as departmentActions from "src/redux/actions/department.action";
import * as yearActions from "src/redux/actions/year.action";
import * as budgetsActions from "src/redux/actions/budgets.action";
import * as getbudgetfaActions from "src/redux/actions/getbudgetfa.action";
import * as loadbudgetfaActions from "src/redux/actions/loadbudgetfa.action";
import * as updatebudgetfaActions from "src/redux/actions/updatebudgetfa.action";
import * as getmonthbudgetActions from "src/redux/actions/getmonthbudget.action";
import * as copymonthbudgetActions from "src/redux/actions/copymonthbudget.action";

import {
  AppBar,
  Tabs,
  Tab,
  TextField,
  Grid,
  Typography,
  makeStyles,
  Button,
  Icon,
  Paper,
  Box,
  CircularProgress,
  Card,
  CardHeader,
  Divider,
  CardContent,
  Container,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
// import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import CustomDialog from "src/components/fragments/CustomDialog";
import PopupDialog from "src/components/fragments/PopupDialog";
import {
  TextField as TextFieldFormik,
  CheckBox as CheckBoxFormik,
} from "formik-material-ui";
import NumberFormat from "react-number-format";
import Page from "src/components/Page";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  formsearch: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "40ch",
    },
  },
  inputEditNumber: {
    width: "10ch",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix=""
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

let monthlist = [
  { M1: 1, NAME: "M1" },
  { M2: 2, NAME: "M2" },
  { M1: 3, NAME: "M3" },
  { M2: 4, NAME: "M4" },
  { M1: 5, NAME: "M5" },
  { M2: 6, NAME: "M6" },
  { M1: 7, NAME: "M7" },
  { M2: 8, NAME: "M8" },
  { M1: 9, NAME: "M9" },
  { M2: 10, NAME: "M10" },
  { M1: 11, NAME: "M11" },
  { M2: 12, NAME: "M12" },
];

export default function BudgetForecastMonthly() {
  const classes = useStyles();

  const [value, setValue] = useState(0);
  const [openDlgconfirm, setopenDlgconfirm] = useState(false);
  const [openDlgconfirmBudget, setopenDlgconfirmBudget] = useState(false);
  const [openDlgconfirmCopy, setopenDlgconfirmCopy] = useState(false);
  const [openPopupDlgSucc, setOpenPopupDlgSucc] = useState(false);
  const [openPopupDlgSuccL, setOpenPopupDlgSuccL] = useState(false);

  const [budgetpId, setbudgetpId] = useState(0);
  const [brandId, setBrandId] = useState(null);
  const [deptId, setDeptId] = useState(null);
  const [yearId, setYearId] = useState(null);
  const [onSubmit, setOnSubmit] = useState(false);
  // const [buheadFullname, setbuheadFullname] = useState("");
  // const [yearCode, setyearCode] = useState();

  const [yearLock, setYearLock] = useState(null);
  // const [yearmaxDate, setMaxDate] = useState("12/31/" + yearCode);
  // const [yearminDate, setMinDate] = useState("01/01/" + yearCode);

  const loginReducer = useSelector((state) => state.loginReducer);
  const budgetmonthReducer = useSelector(
    ({ budgetmonthReducer }) => budgetmonthReducer
  );
  const yearReducer = useSelector(({ yearReducer }) => yearReducer);
  const budgetsReducer = useSelector(({ budgetsReducer }) => budgetsReducer);
  const brandReducer = useSelector(({ brandReducer }) => brandReducer);
  const departmentReducer = useSelector(
    ({ departmentReducer }) => departmentReducer
  );

  const updatebudgetfaReducer = useSelector(
    (state) => state.updatebudgetfaReducer
  );
  const loadbudgetfaReducer = useSelector((state) => state.loadbudgetfaReducer);
  const getbudgetfaReducer = useSelector((state) => state.getbudgetfaReducer);
  const getmonthbudgetReducer = useSelector(
    (state) => state.getmonthbudgetReducer
  );

  const copymonthbudgetReducer = useSelector(
    (state) => state.copymonthbudgetReducer
  );
  const dispatch = useDispatch();

  useEffect(() => {
    // Get Brand

    dispatch(
      brandActions.getBrands(
        loginReducer.result.countryid,
        loginReducer.result.companyid,
        loginReducer.result.secureid
      )
    );

    return () => {
      clearDataDropDown();
      dispatch(
        departmentActions.getDepts(loginReducer.result.countryid, 0, 0, 0)
      );
      dispatch(
        yearActions.getYear(
          loginReducer.result.countryid + loginReducer.result.companyid + 0 + 0
        )
      );
      dispatch(budgetsActions.clearBudgets());
    };
  }, []);

  const checkEditExpense = (rowData) => {
    if (yearLock === 0) {
      if (budgetsReducer.actid === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const checkEditMonth = () => {
    if (getbudgetfaReducer.result.M1_STATUS >= 1) {
      return "never";
    } else {
      return "always";
    }
  };

  const handleChangeBrand = (e) => {
    const data = e.target.value;
    clearDataDropDown();
    setBrandId(data);
    // dispatch(getforecastoneActions.clearForecast1());
    setDeptId(null);
    setOnSubmit(false);
    dispatch(
      departmentActions.getDepts(
        loginReducer.result.countryid,
        loginReducer.result.companyid,
        loginReducer.result.secureid,
        data
      )
    );
    dispatch(
      yearActions.getYear(
        loginReducer.result.countryid + loginReducer.result.companyid + 0 + 0
      )
    );
  };

  const handleChangeDepartment = (e) => {
    const data = e.target.value;
    setDeptId(data);
    clearDataDropDown();
    setYearId(null);
    setOnSubmit(false);
    dispatch(
      yearActions.getYear(
        loginReducer.result.countryid +
          loginReducer.result.companyid +
          brandId +
          data
      )
    );
  };

  const handleChangeYear = (e) => {
    const { BUDGETH_ID, BUDGETH_LOCK } = JSON.parse(e.target.value);

    clearDataDropDown();
    setYearId(BUDGETH_ID);
    setOnSubmit(false);
    setYearLock(BUDGETH_LOCK);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleConfirmDlg = (value) => {
    if (value) {
      // setTimeout(() => {
      // dispatch(deleteprojectActions.deleteProjectById(budgetpId));
      // }, 1000),
      setTimeout(() => {
        // dispatch(getprojectActions.getProject(budgetsReducer.sid));
      }, 1000);
    }
    setopenDlgconfirm(false);
  };

  const handleConfirmDlgBudget = (value) => {
    if (value) {
      // e.preventDefault();
      let data = {
        YEARID: yearId,
        COUNTRYID: loginReducer.result.countryid,
        COMPANYID: loginReducer.result.companyid,
        BRANDID: brandId,
        DEPARTID: deptId,
        MEMID: loginReducer.result.perid,
        SECID: loginReducer.result.secureid,
        // budgetsReducer.sid
      };

      // setTimeout(() => {
      dispatch(loadbudgetfaActions.loadBudgetfa(data)).then((result) => {
        setTimeout(() => {
          dispatch(
            getbudgetfaActions.getBudgetFa(
              loginReducer.result.countryid,
              loginReducer.result.companyid,
              brandId,
              deptId,
              yearId,
              loginReducer.result.secureid
            )
          ).then(() => {
            setOpenPopupDlgSuccL(true);
          });
        }, 1000);
      });
      // }, 1000);

      setopenDlgconfirmBudget(false);
    } else {
      setopenDlgconfirmBudget(false);
    }
  };

  const handlePopupDlgSucc = (value) => {
    if (value) {
      setOpenPopupDlgSucc(false);
    }
  };

  const handlePopupDlgSuccL = (value) => {
    if (value) {
      setOpenPopupDlgSuccL(false);
    }
  };

  const clearDataDropDown = () => {
    dispatch(getbudgetfaActions.clearBudgetfa());
    dispatch(getmonthbudgetActions.clearMonthBudget());
    dispatch(budgetsActions.clearBudgets());

    // dispatch(getforecasttwoActions.clearForecast2());
    // dispatch(getforecastthreeActions.clearForecast3());
  };

  const tableRefDetail = React.createRef();

  const controlButtonLoadbudget = () => {
    if (
      brandId !== null &&
      deptId !== null &&
      yearId !== null &&
      onSubmit &&
      budgetsReducer.sid !== 0
      // checkButtonSubmit()
    ) {
      return false;
    }
    return true;
  };

  const controlButtonCopybudget = () => {
    if (
      brandId !== null &&
      deptId !== null &&
      yearId !== null &&
      onSubmit &&
      budgetsReducer.sid !== 0 &&
      getbudgetfaReducer.result != 0
      // checkButtonSubmit()
    ) {
      return false;
    }
    return true;
  };

  const renderButtonLoadBudget = () => {
    if (!budgetsReducer.isFetching) {
      return (
        <Button
          variant="contained"
          color="default"
          startIcon={<Icon>add</Icon>}
          disabled={controlButtonLoadbudget()}
          onClick={(e) => {
            setopenDlgconfirmBudget(true);
          }}
        >
          Load Budget
        </Button>
      );
    }
    return <CircularProgress />;
  };

  const renderRemark = () => {
    if (getmonthbudgetReducer.result.map((i) => i.BUDGETH_REMARK)[0]) {
      return (
        <Alert icon={false} variant="outlined">
          <Typography variant="h4">
            {getmonthbudgetReducer.result.map((i) => i.BUDGETH_REMARK)[0]}
          </Typography>
        </Alert>
      );
    }
    // return <CircularProgress />;
  };

  const inputOptionsProject = new Promise(function (resolve) {
    // get your data and pass it to resolve()

    if (getmonthbudgetReducer.result) {
      let obj = getmonthbudgetReducer.result.reduce(function (acc, cur, i) {
        // console.log(cur);
        acc[cur.MONTHLY] = cur.MONTHLY_NAME;
        return acc;
      }, {});
      resolve(obj);
    }
    resolve({});
  });

  const renderButtonCopy = () => {
    if (!budgetsReducer.isFetching) {
      return (
        <Button
          variant="contained"
          color="default"
          startIcon={<Icon>add_circle</Icon>}
          disabled={controlButtonCopybudget()}
          onClick={(e) => {
            e.preventDefault();
            Swal.fire({
              icon: "question",
              title: "Please select month.",
              input: "select",
              inputOptions: inputOptionsProject,
              showCancelButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                let data = {
                  YEARID: yearId,
                  COUNTRYID: loginReducer.result.countryid,
                  COMPANYID: loginReducer.result.companyid,
                  BRANDID: brandId,
                  DEPARTID: deptId,
                  MEMID: loginReducer.result.perid,
                  SECID: loginReducer.result.secureid,
                  MONTHLY: result.value,
                };
                dispatch(copymonthbudgetActions.copyMonthBudget(data))
                  .then((result) => {
                    setTimeout(() => {
                      dispatch(
                        getbudgetfaActions.getBudgetFa(
                          loginReducer.result.countryid,
                          loginReducer.result.companyid,
                          brandId,
                          deptId,
                          yearId,
                          loginReducer.result.secureid
                        )
                      ).then(() => {
                        setOpenPopupDlgSucc(true);
                      });
                    }, 1200);
                  })
                  .catch((result) => {
                    // Error Message
                  });
              }
            });
          }}
        >
          Copy
        </Button>
      );
    }
    return <CircularProgress />;
  };
  return (
    // <Alert icon={false} variant="outlined" severity="info">
    //   <Box display="flex" justifyContent="space-between" flexWrap="wrap">
    //     <Box display="flex" flexDirection="row">
    //       <Box mr={5}>
    //         {" "}
    //         <Typography variant="h4">Budget Monthly Forecast</Typography>
    //       </Box>
    //     </Box>
    //   </Box>
    // </Alert>
    <Page className={classes.root} title="Budget Monthly Forecast">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            subheader="For forecast budget"
            title="Budget Monthly Forecast"
          />

          <Divider />
          <CardContent>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setOnSubmit(true);
                dispatch(
                  getbudgetfaActions.getBudgetFa(
                    loginReducer.result.countryid,
                    loginReducer.result.companyid,
                    brandId,
                    deptId,
                    yearId,
                    loginReducer.result.secureid
                  )
                )
                  .then((result) => {
                    dispatch(getmonthbudgetActions.getMonthBudget(yearId));
                    dispatch(
                      budgetsActions.getBudgetsById(
                        loginReducer.result.countryid,
                        loginReducer.result.companyid,
                        brandId,
                        deptId,
                        yearId,
                        loginReducer.result.secureid
                      )
                    );
                    // setTimeout(() => {
                    //   if (result) {
                    //   } else {
                    //   }
                    // }, 1000);
                  })
                  .catch((result) => {});
              }}
            >
              <Grid container xs={12}>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  flex={1}
                  style={{ lineHeight: 4, justifyContent: "space-between" }}
                >
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    onChange={handleChangeBrand}
                    id="brand"
                    label="Brand"
                    autoComplete="investmenttype"
                    autoFocus
                    style={{ width: "20%", minWidth: "10%" }}
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue=""
                  >
                    <option key={0} value="" selected>
                      -
                    </option>
                    {brandReducer.result &&
                      brandReducer.result.map((item) => (
                        <option
                          key={item.ORG_BRAND_ID}
                          value={item.ORG_BRAND_ID}
                        >
                          {item.BRAND}
                        </option>
                      ))}
                  </TextField>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    style={{ width: "50%" }}
                    // value={deptId}
                    onChange={handleChangeDepartment}
                    label="Department"
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue=""
                  >
                    <option key={0} value="" selected>
                      -
                    </option>

                    {departmentReducer.result &&
                      departmentReducer.result.map((item) => (
                        <option
                          key={item.ORG_DEPARTMENT_ID}
                          value={item.ORG_DEPARTMENT_ID}
                        >
                          {item.department}
                        </option>
                      ))}
                  </TextField>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    onChange={handleChangeYear}
                    label="Year"
                    style={{ width: "10%" }}
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue=""
                  >
                    <option key={0} value="" selected>
                      -
                    </option>
                    {yearReducer.result &&
                      yearReducer.result.map((item) => (
                        // <MenuItem value={item}>{item.YEAR_CODE}</MenuItem>
                        <option
                          key={item.YEAR_CODE}
                          value={JSON.stringify(item)}
                        >
                          {/* {item.YEAR_CODE} */}
                          {item.YEAR_SEQ_T}
                        </option>
                      ))}
                  </TextField>
                  <Box>
                    <Button variant="contained" color="default" type="submit">
                      <Icon>search</Icon>Search
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </form>
            <br />
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexWrap="wrap"
                >
                  <Box display="flex" flexDirection="row">
                    <Box mr={5}>{renderButtonLoadBudget()}</Box>
                    <Box mr={5}>{renderButtonCopy()}</Box>
                  </Box>
                  <Box display="flex" flexDirection="row">
                    <Box mr={5}>{renderRemark()}</Box>
                  </Box>
                  {/* <Box display="flex" flexDirection="row">
              <Box>
                <Button
                  variant="contained"
                  color="default"
                  // disabled={checkRecBudget}
                  startIcon={<Icon>refresh</Icon>}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(
                      getbudgetfaActions.getBudgetFa(
                        loginReducer.result.countryid,
                        loginReducer.result.companyid,
                        brandId,
                        deptId,
                        yearId,
                        loginReducer.result.secureid
                      )
                    );
                  }}
                >
                  Refresh data
                </Button>
              </Box>
            </Box> */}
                </Box>
              </Grid>
            </Grid>

            <br />

            <AppBar position="static">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                variant="fullWidth"
                centered
              >
                <Tab
                  style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
                  // Loop month can edit
                  label={
                    budgetsReducer.sid !== 0
                      ? "Budget Forecast Monthly  " +
                        "[  " +
                        getmonthbudgetReducer.result.map(
                          (i) => i.MONTHLY_NAME
                        ) +
                        "  ]  "
                      : "Budget Forecast Monthly"
                  }
                  {...a11yProps(0)}
                />
              </Tabs>
            </AppBar>

            <TabPanel value={value} index={0}>
              {/* Forecast +1 Tab */}
              <Grid container spacing={2}>
                <Paper className={classes.root}>
                  <MaterialTable
                    title={"Budget Forecast Monthly"}
                    tableRef={tableRefDetail}
                    editable={{
                      // ----
                      // isEditable: (rowData) => checkEditExpense(rowData),

                      onRowUpdate: (newData, oldData) =>
                        new Promise((resolve, reject) => {
                          const { BUDGETM_ID } = newData;
                          setTimeout(() => {
                            dispatch(
                              updatebudgetfaActions.updateBudgetfaById(
                                BUDGETM_ID,
                                loginReducer.result.perid,
                                newData
                              )
                            );
                          }, 1000);
                          setTimeout(() => {
                            dispatch(
                              getbudgetfaActions.getBudgetFa(
                                loginReducer.result.countryid,
                                loginReducer.result.companyid,
                                brandId,
                                deptId,
                                yearId,
                                loginReducer.result.secureid
                              )
                            );
                          }, 2000);
                          resolve(newData);
                        }),
                    }}
                    options={{
                      showTitle: false,
                      paging: false,
                      search: true,
                      detailPanelType: "single",
                      exportButton: true,
                      // exportCsv: true,
                      exportAllData: true,
                      toolbarButtonAlignment: "left",
                      searchFieldAlignment: "left",
                      headerStyle: {
                        backgroundColor: "#5c9aff",
                      },
                      rowStyle: {
                        backgroundColor: "#edf4ff",
                      },
                      pageSize: 5,
                      pageSizeOptions: [5, 10, 50, 100],
                      paging: true,
                    }}
                    columns={[
                      {
                        title: "BUDGETM ID ",
                        field: "BUDGETM_ID",
                        editable: "never",
                        hidden: "true",
                      },
                      {
                        title: "Group",
                        field: "ACC_GROUP2",
                        editable: "never",
                      },
                      {
                        title: "Category",
                        field: "ACC_CATEGORY_NM",
                        editable: "never",
                      },
                      {
                        title: "Project Code",
                        field: "BUDGETP_CODE",
                        editable: "never",
                      },
                      {
                        title: "Project Name",
                        field: "BUDGETP_NAME",
                        editable: "never",
                      },
                      {
                        title: "Acc Code.",
                        field: "ACC_CODE",
                        editable: "never",
                      },
                      {
                        title: "Acc Name.",
                        field: "ACC_NAME",
                        editable: "never",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                      },

                      {
                        title: "Total.",
                        field: "TOT_ACTUAL",
                        editable: "never",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.TOT_ACTUAL) {
                            return rowData.TOT_ACTUAL.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Jan.",
                        field: "BUDGETM_M1",
                        // editable: (_, rowData) =>
                        //   (rowData && rowData.M1_STATUS === 2) ||
                        //   rowData.M1_STATUS === 3,
                        editable: (_, rowData) =>
                          rowData && rowData.M1_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M1) {
                            return rowData.BUDGETM_M1.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            // label="react-number-format"
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "Feb.",
                        field: "BUDGETM_M2",
                        editable: (_, rowData) =>
                          rowData && rowData.M2_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M2) {
                            return rowData.BUDGETM_M2.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            // label="react-number-format"
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "Mar.",
                        field: "BUDGETM_M3",
                        editable: (_, rowData) =>
                          rowData && rowData.M3_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M3) {
                            return rowData.BUDGETM_M3.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            // label="react-number-format"
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "Apr.",
                        field: "BUDGETM_M4",
                        editable: (_, rowData) =>
                          rowData && rowData.M4_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M4) {
                            return rowData.BUDGETM_M4.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            // label="react-number-format"
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "May",
                        field: "BUDGETM_M5",
                        editable: (_, rowData) =>
                          rowData && rowData.M5_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M5) {
                            return rowData.BUDGETM_M5.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            // label="react-number-format"
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "Jun.",
                        field: "BUDGETM_M6",
                        editable: (_, rowData) =>
                          rowData && rowData.M6_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M6) {
                            return rowData.BUDGETM_M6.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            // label="react-number-format"
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "Jul.",
                        field: "BUDGETM_M7",
                        editable: (_, rowData) =>
                          rowData && rowData.M7_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M7) {
                            return rowData.BUDGETM_M7.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            // label="react-number-format"
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "Aug.",
                        field: "BUDGETM_M8",
                        editable: (_, rowData) =>
                          rowData && rowData.M8_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M8) {
                            return rowData.BUDGETM_M8.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            // label="react-number-format"
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "Sep.",
                        field: "BUDGETM_M9",
                        editable: (_, rowData) =>
                          rowData && rowData.M9_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M9) {
                            return rowData.BUDGETM_M9.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            // label="react-number-format"
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "Oct.",
                        field: "BUDGETM_M10",
                        editable: (_, rowData) =>
                          rowData && rowData.M10_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M10) {
                            return rowData.BUDGETM_M10.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            // label="react-number-format"
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "Nov.",
                        field: "BUDGETM_M11",
                        editable: (_, rowData) =>
                          rowData && rowData.M11_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M11) {
                            return rowData.BUDGETM_M11.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            // label="react-number-format"
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "Dec.",
                        field: "BUDGETM_M12",
                        editable: (_, rowData) =>
                          rowData && rowData.M12_STATUS > 1,
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.BUDGETM_M12) {
                            return rowData.BUDGETM_M12.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                        editComponent: (props) => (
                          <TextField
                            className={classes.inputEditNumber}
                            value={props.value}
                            onChange={(e) =>
                              props.onChange(
                                e.target.value ? e.target.value : 0
                              )
                            }
                            name="numberformat"
                            id="formatted-numberformat-input"
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                          />
                        ),
                      },
                      {
                        title: "Detail",
                        field: "accdetail",
                        editable: "never",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                        // hidden: "false",
                      },
                    ]}
                    data={
                      getbudgetfaReducer.result ? getbudgetfaReducer.result : []
                    }
                  />
                </Paper>
              </Grid>
            </TabPanel>

            <CustomDialog
              title="Confirmation dialog"
              message="Confirm to Update budget?"
              open={openDlgconfirmBudget}
              onClose={handleConfirmDlgBudget}
              disableBackdropClick
            />
            <PopupDialog
              title="Information Message"
              message={<Alert severity="success">Copy data successful.</Alert>}
              // disabledBtn={getfilesReducer.isFetching ? true : false}
              open={openPopupDlgSucc}
              onClose={handlePopupDlgSucc}
            />
            <PopupDialog
              title="Information Message"
              message={
                <Alert severity="success">Load Budget successful.</Alert>
              }
              // disabledBtn={getfilesReducer.isFetching ? true : false}
              open={openPopupDlgSuccL}
              onClose={handlePopupDlgSuccL}
            />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
